import fireb from "../firebase/fireBase"
import firebase from 'firebase/app'
import 'firebase/auth'
import configureStore from '../store/configureStore'
import { appLoginLog } from "./couldCalls"
import { getDocument, staticQuery } from "./handleDb"
import { deleteArrayItem } from "./utils"
import { getAppConfig } from "./appConfig"
import { getSelectValue } from 'functions/formCreator'

const auth = fireb.auth()
const db = fireb.firestore()

// TODO: this need to be a class in the near future
/* Dear coder: this maybe can by painful but at the end it will be art dude, pure art */

const signInEmailAndPass = async (email, password) => {

    return await auth.signInWithEmailAndPassword(email, password)
        .then(result => {
            // if (result.user.emailVerified) {
            //     localStorage.setItem('logged', result.user.ra)
            //     configureStore.dispatch({
            //         type: 'LOG_IN',
            //         payload: {
            //             userName: result.user.displayName,
            //             userImage: result.user.photoURL,
            //             uid: result.user.uid,
            //             email: result.user.email
            //         }
            //     })
            //     return result.user.uid
            // } else {
            //     fireb.auth().signOut()
            //     return false
            // }

            // TODO: Cuadrar de nuevo la verificacion del mail cuando este listo el dominio.

            localStorage.setItem('logged', result.user.ra)
            configureStore.dispatch({
                type: 'LOG_IN',
                payload: {
                    userName: result.user.displayName,
                    userImage: result.user.photoURL,
                    uid: result.user.uid,
                    email: result.user.email
                }
            })

            return { uid: result.user.uid, email: result.user.email, name: result.user.displayName }

        })
        .then(user => user ? appLoginLog(user) : false)
        .then(res => res ? ({ status: 'ok' }) : ({ status: 'fail_mail' }))
        .catch(error => {
            console.error(error)
            return ({ status: 'fail_user' })
        })
}

const createUserEmailAndPass = async (name, email, password, responseLink) => {
    return await auth.createUserWithEmailAndPassword(email, password)
        .then(result => {
            result.user.updateProfile({
                displayName: name
            })

            result.user.sendEmailVerification({ url: responseLink })
                .catch(error => {
                    console.error(error)
                })

            localStorage.setItem('logged', result.user.ra)
            configureStore.dispatch({
                type: 'LOG_IN',
                payload: {
                    userName: name,
                    userImage: '/assets/images-DEMO/avatars/user.png',
                    uid: result.user.uid,
                    email: result.user.email,
                    authorizedApps: []
                }
            })

            return { uid: result.user.uid, email: result.user.email, name: name }
        })
        .then(user => appLoginLog(user))
        .then(created => {
            if (created === 'ok') {
                return { status: 'ok' }
            }
        })
        .catch(() => {
            return { status: 'fail' }
        })
}

const restorePassword = (email, responseLink, callback) => {

    auth.sendPasswordResetEmail(email, { url: responseLink }).then(() => {
        callback({ status: true })
    }).catch(error => {
        callback({ status: false })
    })

}

const socialLogIn = async (type) => {

    let provider

    if (type === 'facebook') {
        provider = new firebase.auth.FacebookAuthProvider()
    } else if (type === 'google') {
        provider = new firebase.auth.GoogleAuthProvider()
    } else if (type === 'twitter') {
        provider = new firebase.auth.TwitterAuthProvider()
    }

    return await auth.signInWithPopup(provider)
        .then(result => {
            localStorage.setItem('logged', result.user.ra)
            configureStore.dispatch({
                type: 'LOG_IN',
                payload: {
                    userName: result.user.displayName,
                    userImage: result.user.photoURL,
                    uid: result.user.uid,
                    email: result.user.email
                }
            })

            return { uid: result.user.uid, email: result.user.email, name: result.user.displayName }
        })
        .then(user => {

            appLoginLog(user)

        })
        .then(() => ({ status: true }))
        .catch(error => {
            console.error(error)
            return ({ status: false })
        })

}

const sessionControl = callback => {

    auth.onAuthStateChanged(async user => {
        if (user) {
            let authorizedApps = []
            await db.collection('users')
                .doc(user.uid)
                .get()
                .then(dss => {
                    if (dss.exists) {
                        let authApps = dss.data().appsAuthorized
                        authorizedApps = authApps ? authApps : []
                    }
                })

            if (user.photoURL) {
                configureStore.dispatch({
                    type: 'LOG_IN',
                    payload: {
                        userName: user.displayName,
                        userImage: user.photoURL,
                        uid: user.uid,
                        email: user.email,
                        authorizedApps
                    }
                })
            } else {
                configureStore.dispatch({
                    type: 'LOG_IN',
                    payload: {
                        userName: user.displayName,
                        userImage: '/assets/images-DEMO/avatars/user.png',
                        uid: user.uid,
                        email: user.email,
                        authorizedApps
                    }
                })
            }
            getAppConfig(user.uid)
            callback({ status: true, uid: user.uid })
        } else {
            callback({ status: false })
        }
    })

}

const setUserProfile = async (uid, idapp, data) => {

    let getAppsAuth, newProfile = [{ app: idapp, ...data }], sendProfile

    await getDocument(
        'users',
        {
            field: 'uid',
            operator: '==',
            value: uid
        },
        null,
        false
    ).then(res => {
        getAppsAuth = res.appsAuthorized
    })

    if (getAppsAuth) {

        let prevApp = getAppsAuth.find(g => {
            return g.app === idapp
        })

        if (prevApp) {
            let newArr = deleteArrayItem(prevApp, getAppsAuth)
            sendProfile = newProfile.concat(newArr)
        } else {
            sendProfile = newProfile.concat(getAppsAuth)
        }

    } else {
        sendProfile = newProfile
    }

    const Ref = db.collection('users').doc(uid)
    return Ref.update({
        appsAuthorized: sendProfile,
        selectedApp: idapp
    })
}

const setUserAssignations = async (uid, idapp, { assignation }) => {

    let getAppsAssignations, sendAssignation, services = [], places = []

    assignation.forEach(op => {
        if (op.substring(0, 1) === 's') { services.push(op) }
        if (op.substring(0, 1) === 'p') { places.push(op) }
    })

    let newAssignation = [{ app: idapp, places, services }]

    await getDocument(
        'users',
        {
            field: 'uid',
            operator: '==',
            value: uid
        },
        null,
        false
    ).then(res => {
        getAppsAssignations = res.appsAssignations
    })

    if (getAppsAssignations) {
        let prevApp = getAppsAssignations.find(g => g.app === idapp)

        if (prevApp) {
            let newArr = deleteArrayItem(prevApp, getAppsAssignations)
            sendAssignation = newAssignation.concat(newArr)
        } else {
            sendAssignation = newAssignation.concat(getAppsAssignations)
        }
    } else {
        sendAssignation = newAssignation
    }

    let Ref = db.collection('users').doc(uid)
    return Ref.update({
        appsAssignations: sendAssignation,
    })

}

const verifyModule = module => {
    let p = configureStore.getState().user.get('permissions').toJS()
    if (p.length > 0) {
        let verify = p.find(m => m === module)
        if (verify) return false
        else return true
    } else {
        return false
    }
}

const getLoggedUserAndUserProfileData = async (appconfig, component, record) => {

    const isForm = appconfig.auth.form !== undefined
    const returnData = []
    let fields, data

    if (isForm) {
        await staticQuery(
            `apps/${appconfig.appid}/formData`,
            [{
                field: 'formid',
                operator: '==',
                value: appconfig.auth.form.formId
            }, {
                field: 'uEmail',
                operator: '==',
                value: record.uEmail
            }]
        ).then(formData => data = formData[0])

        await staticQuery(
            `apps/${appconfig.appid}/formFields`,
            [{
                field: 'formid',
                operator: '==',
                value: appconfig.auth.form.formId
            }]
        ).then(formFields => fields = formFields)
    }

    if (component.data.selectedFields) {
        const selectedFields = component.data.selectedFields

        for (let i = 0; i in selectedFields; i++) {
            let fieldProps = fields.find(f => f.name === selectedFields[i])

            if (fieldProps.type === 'select') {
                let value

                await getSelectValue(
                    appconfig.appid,
                    fieldProps.source,
                    data[selectedFields[i]]
                )
                    .then(d => value = d)

                returnData.push({
                    label: fieldProps.label,
                    value: value
                })
            } else {
                returnData.push({
                    label: fieldProps.label,
                    value: data[selectedFields[i]]
                })
            }
        }
    }

    return returnData
}

export {
    signInEmailAndPass,
    createUserEmailAndPass,
    restorePassword,
    socialLogIn,
    sessionControl,
    setUserProfile,
    setUserAssignations,
    verifyModule,
    getLoggedUserAndUserProfileData
}